import {Component, Input, OnDestroy} from "@angular/core";
import {ScreenLayoutEditorModel} from "./screen-layout-editor.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {ColorEditControlComponent} from "../../../../framework/common-controls/edit-controls/color-edit-control/color-edit-control.component";

/**
 * Lays out the screen layout menus and controls
 */
@Component({
    selector: "wbo-screen-layout-editor",
    templateUrl: "./screen-layout-editor.component.html",
    styleUrls: ["./screen-layout-editor.component.scss"],
    providers: [ScreenLayoutEditorModel]
})
export class ScreenLayoutEditorComponent {
    ScreenLayoutEditorModel = ScreenLayoutEditorModel;

    private _courseDefinitionId: number;

    constructor(public screenLayoutEditorModel: ScreenLayoutEditorModel, public editService: EditService) {
    }

    @Input() get courseDefinitionId(): number {
        return this._courseDefinitionId;
    }

    set courseDefinitionId(value: number) {
        this._courseDefinitionId = value;
        this.screenLayoutEditorModel.updateCourses(this.courseDefinitionId);
    }

    get paintingColour(): string {
        return this.screenLayoutEditorModel.paintingColour ? ColorEditControlComponent.toColorHex(this.screenLayoutEditorModel.paintingColour) : "white";
    }

    get paintingForeColour(): string {
        return this.screenLayoutEditorModel.paintingForeColour ? ColorEditControlComponent.toColorHex(this.screenLayoutEditorModel.paintingForeColour) : "black";
    }

    painting(): void {
        if (this.screenLayoutEditorModel.painting) {
            this.screenLayoutEditorModel.stopPainting();
        } else {
            this.screenLayoutEditorModel.startPainting();
        }
    }
}
